var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticStyle: {
            "font-size": "15px",
            color: "#1a1a1a",
            "font-weight": "600",
            "text-align": "center",
            padding: "15px 0"
          }
        },
        [_vm._v("盘点单信息")]
      ),
      _vm._v(" "),
      _c(
        "table",
        {
          staticClass: "simple-tbl",
          staticStyle: {
            width: "100%",
            "table-layout": "fixed",
            "border-collapse": "collapse",
            "border-spacing": "2px",
            "border-color": "gray",
            color: "#666",
            "font-size": "12px",
            "word-break": "break-strict"
          }
        },
        [
          _c("tbody", { staticClass: "body" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v(_vm._s(_vm.voucher.title))]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(2),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [_vm._v(_vm._s(_vm.voucher.no))]),
                          _vm._v(" "),
                          _vm.voucher.spotFlag
                            ? _c("el-tag", { attrs: { type: "primary" } }, [
                                _vm._v("抽盘")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.voucher.quickFlag
                            ? _c("el-tag", { attrs: { type: "primary" } }, [
                                _vm._v("快盘")
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(3),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm.voucher.openMode
                            ? _c("span", [_vm._v("明盘")])
                            : _c("span", [_vm._v("暗盘")])
                        ]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("盘点业务单元")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.voucher.retailerBizUnitName))
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("盘点业务部门")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.voucher.retailerComName))
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("盘点仓库")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v(_vm._s(_vm.voucher.warehouseName))]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("创建机构")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.voucher.creatorComName))
                          ])
                        ]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(4),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("sapn", [
                            _vm._v(_vm._s(_vm.voucher.principalName))
                          ])
                        ],
                        1
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(5),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm.voucher.confirmed
                            ? _c("span", [_vm._v("已确认")])
                            : _c("span", [_vm._v("未确认")])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(6),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.voucher.spotPrincipalName))
                          ])
                        ]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _vm.voucher.useMode == 0
                ? _c(
                    "td",
                    {
                      staticStyle: {
                        border: "1px solid #1a1a1a",
                        "vertical-align": "middle",
                        padding: "10px 4px"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "info-item ",
                          staticStyle: { overflow: "hidden" }
                        },
                        [
                          _vm._m(7),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "value",
                              staticStyle: {
                                "padding-left": "76px",
                                "white-space": "normal",
                                "word-break": "break-all"
                              }
                            },
                            [
                              _vm.voucher.spotConfirmed
                                ? _c("span", [_vm._v("已确认")])
                                : _c("span", [_vm._v("未确认")])
                            ]
                          )
                        ]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(8),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _vm.voucher.state == 0
                            ? _c("span", [_vm._v("未开始")])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.voucher.state == 1
                            ? _c("span", [_vm._v("已开始")])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.voucher.state == 2
                            ? _c("span", [_vm._v("已结束")])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.voucher.state == -1
                            ? _c("span", [_vm._v("已取消")])
                            : _vm._e()
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(9),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.voucher.startTime))])]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("结束时间")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.voucher.endTime))])]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("取消时间")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.voucher.cancelTime))])]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("创建时间")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.voucher.createTime))])]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("创建人")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.voucher.creatorName))])]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("创建机构")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.voucher.creatorComName))
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("资产类型")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.voucher.assetType == 2 ? "耗材" : "非耗材"
                              )
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  },
                  attrs: { colspan: "3" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_vm._v("备注")]
                      ),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.voucher.memo))])
                    ]
                  )
                ]
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "table",
        {
          staticClass: "simple-tbl",
          staticStyle: {
            width: "100%",
            "table-layout": "fixed",
            "border-collapse": "collapse",
            "border-spacing": "2px",
            "border-color": "gray",
            color: "#666",
            "font-size": "12px",
            "word-break": "break-strict"
          }
        },
        [
          _c("tbody", { staticClass: "body" }, [
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px",
                    "text-align": "center",
                    color: "#1a1a1a",
                    "font-weight": "600",
                    "background-color": "#efefef",
                    "font-size": "12px"
                  },
                  attrs: { colspan: "3" }
                },
                [_c("span", [_vm._v(_vm._s("盘点耗材统计信息"))])]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_c("span", [_vm._v(_vm._s("盘点耗材数量"))])]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.voucher.durableTotalCount))
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_c("span", [_vm._v(_vm._s("已盘耗材数量"))])]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.voucher.durableCheckedCount))
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label",
                          staticStyle: {
                            width: "76px",
                            float: "left",
                            color: "#1a1a1a",
                            "font-weight": "600",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [_c("span", [_vm._v(_vm._s("未盘耗材数量"))])]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.voucher.durableTotalCount -
                                  _vm.voucher.durableCheckedCount
                              )
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(10),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.voucher.durableCheckedMoreCount))
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(11),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.voucher.durableCheckedLackCount))
                          ])
                        ]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(12),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.voucher.durableOuterCount))
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "info-item ",
                      staticStyle: { overflow: "hidden" }
                    },
                    [
                      _vm._m(13),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "value",
                          staticStyle: {
                            "padding-left": "76px",
                            "white-space": "normal",
                            "word-break": "break-all"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.voucher.durablePostAddedCount))
                          ])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c("td", {
                staticStyle: {
                  border: "1px solid #1a1a1a",
                  "vertical-align": "middle",
                  padding: "10px 4px"
                }
              })
            ]),
            _vm._v(" "),
            _vm._m(14),
            _vm._v(" "),
            _c("tr", { staticClass: "row" }, [
              _c(
                "td",
                {
                  staticStyle: {
                    border: "1px solid #1a1a1a",
                    "vertical-align": "middle",
                    padding: "10px 4px",
                    height: "120px"
                  },
                  attrs: { colspan: "3" }
                },
                [_c("span", [_vm._v(_vm._s(_vm.voucher.postAddedMemo))])]
              )
            ]),
            _vm._v(" "),
            _vm._m(15)
          ])
        ]
      ),
      _vm._v(" "),
      [
        _vm.durableItemList != null && _vm.durableItemList.length > 0
          ? [
              _c(
                "div",
                {
                  staticStyle: {
                    "font-size": "15px",
                    color: "#1a1a1a",
                    "font-weight": "600",
                    "text-align": "center",
                    padding: "15px 0"
                  }
                },
                [_vm._v("耗材管理")]
              ),
              _vm._v(" "),
              _vm._l(_vm.durableItemList, function(durableItem) {
                return _c(
                  "div",
                  {
                    staticStyle: {
                      overflow: "hidden",
                      border: "1px solid rgb(26, 26, 26)",
                      "margin-top": "10px",
                      padding: "5px 2px 10px 2px"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          overflow: "hidden",
                          width: "33.33%",
                          float: "left",
                          "margin-top": "5px",
                          "font-size": "12px"
                        }
                      },
                      [
                        _vm._m(16, true),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "padding-left": "76px",
                              "white-space": "normal",
                              "word-break": "break-all",
                              color: "#666666",
                              "word-wrap": "break-word"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(durableItem.tmpNo) +
                                "\n                    "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          overflow: "hidden",
                          width: "33.33%",
                          float: "left",
                          "margin-top": "5px",
                          "font-size": "12px"
                        }
                      },
                      [
                        _vm._m(17, true),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "padding-left": "76px",
                              "white-space": "normal",
                              "word-break": "break-all",
                              color: "#666666",
                              "word-wrap": "break-word"
                            }
                          },
                          [
                            _c("span", [_vm._v(_vm._s(durableItem.title))]),
                            _vm._v(" "),
                            durableItem.postAdded
                              ? _c("el-tag", { attrs: { type: "primary" } }, [
                                  _vm._v("追加")
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            durableItem.outerFlag
                              ? _c("el-tag", { attrs: { type: "primary" } }, [
                                  _vm._v("助手")
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          overflow: "hidden",
                          width: "33.33%",
                          float: "left",
                          "margin-top": "5px",
                          "font-size": "12px"
                        }
                      },
                      [
                        _vm._m(18, true),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "padding-left": "76px",
                              "white-space": "normal",
                              "word-break": "break-all",
                              color: "#666666",
                              "word-wrap": "break-word"
                            }
                          },
                          [_vm._v(_vm._s(durableItem.name || ""))]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          overflow: "hidden",
                          width: "33.33%",
                          float: "left",
                          "margin-top": "5px",
                          "font-size": "12px"
                        }
                      },
                      [
                        _vm._m(19, true),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "padding-left": "76px",
                              "white-space": "normal",
                              "word-break": "break-all",
                              color: "#666666",
                              "word-wrap": "break-word"
                            }
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(durableItem.model || "") +
                                "\n                    "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          overflow: "hidden",
                          width: "33.33%",
                          float: "left",
                          "margin-top": "5px",
                          "font-size": "12px"
                        }
                      },
                      [
                        _vm._m(20, true),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "padding-left": "76px",
                              "white-space": "normal",
                              "word-break": "break-all",
                              color: "#666666",
                              "word-wrap": "break-word"
                            }
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(durableItem.fixedSpec || "") +
                                "\n                    "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          overflow: "hidden",
                          width: "33.33%",
                          float: "left",
                          "margin-top": "5px",
                          "font-size": "12px"
                        }
                      },
                      [
                        _vm._m(21, true),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "padding-left": "76px",
                              "white-space": "normal",
                              "word-break": "break-all",
                              color: "#666666",
                              "word-wrap": "break-word"
                            }
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(durableItem.catName) +
                                "\n                    "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          overflow: "hidden",
                          width: "33.33%",
                          float: "left",
                          "margin-top": "5px",
                          "font-size": "12px"
                        }
                      },
                      [
                        _vm._m(22, true),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "padding-left": "76px",
                              "white-space": "normal",
                              "word-break": "break-all",
                              color: "#666666",
                              "word-wrap": "break-word"
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.getDevcGroupNameByCatId(durableItem.catId)
                                )
                              )
                            ])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          overflow: "hidden",
                          width: "33.33%",
                          float: "left",
                          "margin-top": "5px",
                          "font-size": "12px"
                        }
                      },
                      [
                        _vm._m(23, true),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "padding-left": "76px",
                              "white-space": "normal",
                              "word-break": "break-all",
                              color: "#666666",
                              "word-wrap": "break-word"
                            }
                          },
                          [_vm._v(_vm._s(durableItem.brandName))]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          overflow: "hidden",
                          width: "33.33%",
                          float: "left",
                          "margin-top": "5px",
                          "font-size": "12px"
                        }
                      },
                      [
                        _vm._m(24, true),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "padding-left": "76px",
                              "white-space": "normal",
                              "word-break": "break-all",
                              color: "#666666",
                              "word-wrap": "break-word"
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(durableItem.assignedStaffName))
                            ])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          overflow: "hidden",
                          width: "33.33%",
                          float: "left",
                          "margin-top": "5px",
                          "font-size": "12px"
                        }
                      },
                      [
                        _vm._m(25, true),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "padding-left": "76px",
                              "white-space": "normal",
                              "word-break": "break-all",
                              color: "#666666",
                              "word-wrap": "break-word"
                            }
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(durableItem.checkerName) +
                                "\n                    "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          overflow: "hidden",
                          width: "33.33%",
                          float: "left",
                          "margin-top": "5px",
                          "font-size": "12px"
                        }
                      },
                      [
                        _vm._m(26, true),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "padding-left": "76px",
                              "white-space": "normal",
                              "word-break": "break-all",
                              color: "#666666",
                              "word-wrap": "break-word"
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(durableItem.checked ? "是" : "否"))
                            ])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          overflow: "hidden",
                          width: "33.33%",
                          float: "left",
                          "margin-top": "5px",
                          "font-size": "12px"
                        }
                      },
                      [
                        _vm._m(27, true),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "padding-left": "76px",
                              "white-space": "normal",
                              "word-break": "break-all",
                              color: "#666666",
                              "word-wrap": "break-word"
                            }
                          },
                          [
                            durableItem.checked || _vm.voucher.state == 2
                              ? _c("span", [
                                  durableItem.checkedDelta == 0
                                    ? _c(
                                        "span",
                                        { staticClass: "font-green" },
                                        [_vm._v("正常")]
                                      )
                                    : durableItem.checkedDelta > 0
                                    ? _c("span", { staticClass: "font-red" }, [
                                        _vm._v("盘盈")
                                      ])
                                    : _c("span", { staticClass: "font-red" }, [
                                        _vm._v("盘亏")
                                      ])
                                ])
                              : _vm._e()
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          overflow: "hidden",
                          width: "33.33%",
                          float: "left",
                          "margin-top": "5px",
                          "font-size": "12px"
                        }
                      },
                      [
                        _vm._m(28, true),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "padding-left": "76px",
                              "white-space": "normal",
                              "word-break": "break-all",
                              color: "#666666",
                              "word-wrap": "break-word"
                            }
                          },
                          [_c("span", [_vm._v(_vm._s(durableItem.checkTime))])]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          overflow: "hidden",
                          width: "33.33%",
                          float: "left",
                          "margin-top": "5px",
                          "font-size": "12px"
                        }
                      },
                      [
                        _vm._m(29, true),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "padding-left": "76px",
                              "white-space": "normal",
                              "word-break": "break-all",
                              color: "#666666",
                              "word-wrap": "break-word"
                            }
                          },
                          [
                            durableItem.checked || _vm.voucher.state == 2
                              ? _c("span", [
                                  _vm._v(_vm._s(durableItem.checkedQuantity))
                                ])
                              : _vm._e()
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          overflow: "hidden",
                          width: "33.33%",
                          float: "left",
                          "margin-top": "5px",
                          "font-size": "12px"
                        }
                      },
                      [
                        _vm._m(30, true),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "padding-left": "76px",
                              "white-space": "normal",
                              "word-break": "break-all",
                              color: "#666666",
                              "word-wrap": "break-word"
                            }
                          },
                          [
                            durableItem.checked || _vm.voucher.state == 2
                              ? _c("span", [
                                  _vm._v(_vm._s(durableItem.checkedDelta))
                                ])
                              : _vm._e()
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          overflow: "hidden",
                          width: "33.33%",
                          float: "left",
                          "margin-top": "5px",
                          "font-size": "12px"
                        }
                      },
                      [
                        _vm._m(31, true),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "padding-left": "76px",
                              "white-space": "normal",
                              "word-break": "break-all",
                              color: "#666666",
                              "word-wrap": "break-word"
                            }
                          },
                          [_c("span", [_vm._v(_vm._s(durableItem.checkMemo))])]
                        )
                      ]
                    )
                  ]
                )
              })
            ]
          : _vm._e()
      ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "row" }, [
      _c(
        "td",
        {
          staticStyle: {
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px",
            "text-align": "center",
            color: "#1a1a1a",
            "font-weight": "600",
            "background-color": "#efefef",
            "font-size": "12px"
          },
          attrs: { colspan: "3" }
        },
        [_c("span", [_vm._v("基本信息")])]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("盘点单名称")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("盘点单号")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("盘点方式")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("自盘负责人")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("自盘负责人是否确认")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("抽盘负责人")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("抽盘负责人是否确认")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("状态")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("开始时间")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("盘盈数量")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("盘亏数量")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("外部盘点数量")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "label",
        staticStyle: {
          width: "76px",
          float: "left",
          color: "#1a1a1a",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("span", [_vm._v("追加盘点数量")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "row" }, [
      _c(
        "td",
        {
          staticStyle: {
            "font-weight": "600",
            "font-size": "15px",
            border: "1px solid #1a1a1a",
            color: "#1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px"
          },
          attrs: { colspan: "3" }
        },
        [_c("span", [_vm._v("结果说明")])]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "row" }, [
      _c(
        "td",
        {
          staticStyle: {
            "text-align": "right",
            border: "1px solid #1a1a1a",
            "vertical-align": "middle",
            padding: "10px 4px"
          },
          attrs: { colspan: "3" }
        },
        [_vm._v("(耗材负责人审核)可上传代替审核")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "76px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("系统编号")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "76px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("耗材描述全称")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "76px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("名称")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "76px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("型号")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "76px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("规格")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "76px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("分类")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "76px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("分类分组")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "76px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("品牌")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "76px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("指定盘点人")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "76px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("盘点人")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "76px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("是否已盘")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "76px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("盘点结果")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "76px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("盘点时间")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "76px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("实盘数量")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "76px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("盘点差值")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          width: "76px",
          float: "left",
          color: "rgb(26, 26, 26)",
          "font-weight": "600",
          "white-space": "normal",
          "word-break": "break-all"
        }
      },
      [_c("label", [_vm._v("情况描述")])]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5180c1be", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5180c1be","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/retailer/ShopStuffStockCheckVoucherForPdf.vue
// module id = 3192
// module chunks = 0